import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CardViewer } from '../board-v3.types';
import {
  getBoardPresenceViewerAvatarUrl,
  getBoardPresenceViewerTitle,
  getBoardPresenceViewersTitle,
} from '../board-v3-presence.utils';

@Component({
  selector: 'app-board-v3-presence-avatars',
  templateUrl: './presence-avatars.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BoardV3PresenceAvatarsComponent {
  @Input() viewers: CardViewer[] = [];
  @Input() visibleCount = 3;
  @Input() avatarSize = '28px';
  @Input() stackClass = '-space-x-2';
  @Input() avatarWrapperClass = '';
  @Input() extraClass = 'h-7 min-w-7 bg-white px-1.5 text-xs text-slate-700';
  @Input() showDropdown = false;
  @Input() showTooltips = false;

  get visibleViewers(): CardViewer[] {
    return this.viewers.slice(0, this.visibleCount);
  }

  get extraViewerCount(): number {
    return Math.max(this.viewers.length - this.visibleViewers.length, 0);
  }

  get extraViewersTitle(): string {
    return this.viewers.slice(this.visibleCount).map((viewer) => this.getViewerTitle(viewer)).join('\n');
  }

  get viewersTitle(): string {
    return getBoardPresenceViewersTitle(this.viewers);
  }

  getViewerAvatarUrl(viewer: CardViewer): string | undefined {
    return getBoardPresenceViewerAvatarUrl(viewer);
  }

  getViewerTitle(viewer: CardViewer): string {
    return getBoardPresenceViewerTitle(viewer);
  }
}
